import React, { ReactElement, InputHTMLAttributes } from "react";
import HdnKeuzelijst, { HdnKeuzelijstProps } from "./HdnKeuzelijst";
import classnames from "classnames";
import { LabelProps, Label } from "adviesbox-shared";

type LabeledHdnKeuzelijstProps = LabelProps & HdnKeuzelijstProps & { appendLabelChildren?: ReactElement | null };

const LabeledHdnKeuzelijst = ({
  berichtSoortType,
  caption,
  keuzelijst,
  name,
  tooltip,
  appendChildren,
  readonly,
  visible,
  fieldSize,
  emptyValue,
  filter,
  labelColSize = 6,
  onChange,
  appendLabelChildren,
  useHdnData,
  verplicht
}: LabeledHdnKeuzelijstProps & InputHTMLAttributes<HTMLSelectElement>): ReactElement => {
  const inputColSize = labelColSize < 12 ? 12 - labelColSize : 12;

  return (
    <div
      className={classnames("form-group form-row", {
        invisible: visible === false
      })}
    >
      <div className={`col-${labelColSize}`}>
        <Label caption={caption} name={name} tooltip={tooltip} appendChildren={appendLabelChildren} verplicht/>
      </div>
      <div className={`col-${inputColSize}`}>
        <HdnKeuzelijst
          berichtSoortType={berichtSoortType}
          keuzelijst={keuzelijst}
          name={name}
          filter={filter}
          appendChildren={appendChildren}
          readonly={readonly}
          fieldSize={fieldSize}
          emptyValue={emptyValue}
          onChange={onChange}
          useHdnData={useHdnData}
        />
      </div>
    </div>
  );
};

export default LabeledHdnKeuzelijst;
